module.exports = __webpack_public_path__ + "static/media/bg-left-img-3.36c4957a.jpg";